(function () {
  function initProductCardMedia(media) {
    if (media.dataset.sstProductCardMediaReady === 'true') return;
    media.dataset.sstProductCardMediaReady = 'true';

    var track = media.querySelector('.sst-product__media-slider');
    var dotsScope = media.closest('.sst-product') || media;
    var dots = Array.from(dotsScope.querySelectorAll('[data-sst-product-card-dot]'));
    var frame = null;
    var suppressCardClick = false;

    if (!track || dots.length < 2) return;

    function slides() {
      return Array.from(track.querySelectorAll('[data-sst-product-card-slide]'));
    }

    function setActive(index) {
      dots.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.dataset.index === String(index));
      });
    }

    function nearestSlide() {
      var slideItems = slides();
      if (!slideItems.length) return null;

      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + track.clientWidth / 2;
      var nearest = slideItems[0];
      var nearestDistance = Infinity;

      slideItems.forEach(function (slide) {
        var rect = slide.getBoundingClientRect();
        var distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < nearestDistance) {
          nearest = slide;
          nearestDistance = distance;
        }
      });

      return nearest;
    }

    function updateActive() {
      frame = null;
      var nearest = nearestSlide();
      if (!nearest) return;
      setActive(nearest.dataset.index);
    }

    function requestUpdate() {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(updateActive);
    }

    function scrollToIndex(index) {
      var slideItems = slides();
      var boundedIndex = Math.max(0, Math.min(index, slideItems.length - 1));
      var next = slideItems[boundedIndex];
      if (!next) return;

      track.scrollTo({
        left: boundedIndex * track.clientWidth,
        behavior: 'smooth',
      });
      setActive(next.dataset.index);
    }

    function currentIndex() {
      var nearest = nearestSlide();
      return nearest ? Number(nearest.dataset.index) || 0 : 0;
    }

    function activateDot(dot, event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }
      suppressCardClick = true;
      window.setTimeout(function () { suppressCardClick = false; }, 400);
      scrollToIndex(Number(dot.dataset.index) || 0);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('pointerdown', function (event) {
        activateDot(dot, event);
      });
      dot.addEventListener('touchend', function (event) {
        activateDot(dot, event);
      });
      dot.addEventListener('click', function (event) {
        activateDot(dot, event);
      });
    });

    var arrows = Array.from(dotsScope.querySelectorAll('[data-sst-product-card-arrow]'));
    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        suppressCardClick = true;
        window.setTimeout(function () { suppressCardClick = false; }, 400);
        var direction = arrow.dataset.sstProductCardArrow === 'prev' ? -1 : 1;
        scrollToIndex(currentIndex() + direction);
      });
    });

    track.addEventListener('scroll', requestUpdate, { passive: true });

    var isDragging = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;
    var dragStartIndex = 0;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse') return;
      isDragging = true;
      dragMoved = false;
      dragStartX = event.clientX;
      dragStartScrollLeft = track.scrollLeft;
      dragStartIndex = currentIndex();
      track.setPointerCapture(event.pointerId);
      event.preventDefault();
    });
    track.addEventListener('pointermove', function (event) {
      if (!isDragging) return;
      var deltaX = event.clientX - dragStartX;
      if (Math.abs(deltaX) > 4) dragMoved = true;
      track.scrollLeft = dragStartScrollLeft - deltaX;
    });
    track.addEventListener('pointerup', function (event) {
      if (!isDragging) return;
      isDragging = false;
      if (!dragMoved) return;

      var deltaX = event.clientX - dragStartX;
      suppressCardClick = true;
      window.setTimeout(function () { suppressCardClick = false; }, 400);

      if (Math.abs(deltaX) < 30) {
        scrollToIndex(dragStartIndex);
      } else {
        scrollToIndex(dragStartIndex + (deltaX < 0 ? 1 : -1));
      }
    });
    track.addEventListener('click', function (event) {
      if (!dragMoved) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      dragMoved = false;
    }, true);

    var card = media.closest('.sst-product');
    if (card) {
      card.addEventListener('click', function (event) {
        if (!suppressCardClick && !event.target.closest('[data-sst-product-card-dot]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    }

    window.addEventListener('resize', requestUpdate, { passive: true });
    requestUpdate();
  }

  function initProductCardMediaAll(root) {
    if (root.matches && root.matches('[data-sst-product-card-media]')) initProductCardMedia(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-sst-product-card-media]').forEach(initProductCardMedia);
  }

  initProductCardMediaAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initProductCardMediaAll(event.target);
  });

  document.addEventListener('product-recommendations:loaded', function (event) {
    if (event.detail && event.detail.target) initProductCardMediaAll(event.detail.target);
  });

  if (window.sstAddToCartHandlerBound) return;
  window.sstAddToCartHandlerBound = true;

  function updateCartCount() {
    fetch(window.routes.cart_url + '.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-sst-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sst-add-to-cart]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.getAttribute('aria-disabled') === 'true') return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var cartDrawer = document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cartDrawer) {
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);
      cartDrawer.setActiveElement(button);
    }

    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || response.message);
        button.setAttribute('aria-pressed', 'true');
        updateCartCount();
        if (!cartDrawer || !response.sections || !response.sections['cart-drawer']) {
          window.location = window.routes.cart_url;
          return;
        }

        var freshDrawer = new DOMParser()
          .parseFromString(response.sections['cart-drawer'], 'text/html')
          .querySelector('#CartDrawer');
        var liveDrawer = document.getElementById('CartDrawer');
        if (freshDrawer && liveDrawer) liveDrawer.innerHTML = freshDrawer.innerHTML;

        cartDrawer.classList.remove('is-empty');
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        cartDrawer.open(button);
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');
      });
  });
})();
